import { ICompany, IEntity, IPrincipal, getTypeForEntity } from '@ViewModels';
import { getCompanyInitials, getPrincipalInitials } from './NameUtils';

interface EntityViewModelLike {
	toJs(): AvatarEntity;
}

type AvatarEntity = IEntity | IPrincipal;

const isEntityViewModel = (value: AvatarEntity | EntityViewModelLike): value is EntityViewModelLike =>
	'toJs' in value && typeof value.toJs === 'function';

export function getAvatarProps(value?: AvatarEntity | EntityViewModelLike): { fallbackText?: string; imgSrc?: string } {
	if (!value) {
		return {};
	}

	const entity = isEntityViewModel(value) ? value.toJs() : value;
	if (getTypeForEntity(entity as IEntity) === 'company') {
		return { fallbackText: getCompanyInitials(entity as ICompany) };
	}

	const principal = entity as IPrincipal;
	return {
		fallbackText: getPrincipalInitials(principal),
		imgSrc: principal.profilePic,
	};
}
